export const FILTER_STATUS = {
    Online: 'online',
    Offline: 'offline',
    All: 'all',
}